// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"204":"ce6700e1","855":"6a5d8602","862":"087ce453","961":"f6da76e8"}[chunkId] + ".css";
};